(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/skeleton.js') >= 0) return;  svs.modules.push('/modules/tipset/views/skeleton.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.skeleton = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["svs-tipset-skeleton_partial"],depth0,{"name":"svs-tipset-skeleton_partial","data":data,"indent":"      ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = "";

  stack1 = ((helper = (helper = helpers.isMobile || (depth0 != null ? depth0.isMobile : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"isMobile","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!helpers.isMobile) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"4":function(container,depth0,helpers,partials,data) {
    return "";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["svs-tipset-skeleton_partial"],depth0,{"name":"svs-tipset-skeleton_partial","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = "";

  stack1 = ((helper = (helper = helpers.isMobile || (depth0 != null ? depth0.isMobile : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"isMobile","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!helpers.isMobile) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"9":function(container,depth0,helpers,partials,data) {
    return "  <div class=\"betslip-position-tag\"></div>\n  <div id=\"betslip-wrapper\" class=\"betslip-wrapper\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id=\"tipset-root\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isStartPage : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = (helpers.feature || (depth0 && depth0.feature) || helpers.helperMissing).call(alias1,"ft-betslip",{"name":"feature","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['svs-tipset-skeleton'] = svs.tipset.templates.skeleton;
})(svs, Handlebars);

 })(window);